import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/scrape`;

export const scrapeFacebook = async (page) => {
  const res = await axiosInstance.get(`${BASE_URL}/facebook-page`, {
    ...getAuthHeaders(),
    params: { page, limit: 10 },
  });
  return res.data;
};

export const scrapeYoutube = async (channel) => {
  const res = await axiosInstance.get(`${BASE_URL}/youtube-channel-comments`, {
    ...getAuthHeaders(),
    params: { channel, limit: 10 },
  });
  return res.data;
};

export const scrapeInstagram = async (profile) => {
  const res = await axiosInstance.get(`${BASE_URL}/instagram-page`, {
    ...getAuthHeaders(),
    params: { profile, limit: 10 },
  });
  return res.data;
};

export const getSocialMediaTasks = async (source) => {
  const res = await axiosInstance.get(`${BASE_URL}/social-media/tasks`, {
    ...getAuthHeaders(),
    params: source ? { source } : {},
  });
  return res.data;
};

export const getTaskByIdApi = async (taskId) => {
  const res = await axiosInstance.get(`/tasks/${taskId}`, getAuthHeaders());
  return res.data;
};
